/**
 * Screen breakpoints (px) — the single source shared between the web Tailwind
 * config (`theme.extend.screens`, imported there via jiti) and runtime
 * media-query hooks, so a `md:`/`xl:` class and `useMinWidth` can never drift.
 * `sm`–`xl` mirror Tailwind's framework defaults; `2xl`–`4xl` are Dermloop
 * overrides.
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1500,
  '3xl': 1850,
  '4xl': 2000,
} as const;

export type Breakpoint = keyof typeof breakpoints;

/** `theme.extend.screens` map (`{ md: '768px', … }`) derived from breakpoints. */
export const tailwindScreens = Object.fromEntries(
  Object.entries(breakpoints).map(([name, px]) => [name, `${px}px`]),
) as Record<keyof typeof breakpoints, string>;
